import React, { useEffect, useState } from 'react';
import { Menu, X, ArrowUpRight } from 'lucide-react';

const navLinks = [
  { label: 'About Us', href: '#about' },
  { label: 'Capabilities', href: '#capabilities' },
  { label: 'Data Coverage', href: '#data-coverage' },
  { label: 'ABM Solutions', href: '#abm-solutions' },
  { label: 'Case Studies', href: '#case-studies' },
  { label: 'Media', href: '#media-anchor' },
  { label: 'Contact', href: '#contact' },
];

const LOGO_URL = '/assets/evolvebpm-logo.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0F1C40]/90 backdrop-blur-md border-b border-white/10' : 'bg-transparent'}`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#about" className="flex items-center">
          <div className="bg-white rounded-lg px-3 py-2 shadow-lg">
            <img src={LOGO_URL} alt="EvolveBPM" className="h-8 w-auto" />
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-6">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} className="text-[13px] text-white/70 hover:text-[#4ECDC4] link-under">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href="#contact" className="hidden md:inline-flex items-center gap-1.5 bg-[#4ECDC4] text-[#0F1C40] pl-4 pr-3 py-2 rounded-full text-[13px] font-semibold hover:bg-white transition-colors duration-300">
            Book a call
            <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={2.5} />
          </a>
          <button onClick={() => setOpen(!open)} className="lg:hidden p-2 -mr-2 text-[#F1EDE4]">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0F1C40] border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-base text-white/80">
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
